export default __webpack_public_path__ + "organization.83bba90466fe5793f06a.svg";